import { render, staticRenderFns } from "./InvoiceDetailPage.vue?vue&type=template&id=cd6c36c8&"
import script from "./InvoiceDetailPage.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd6c36c8')) {
      api.createRecord('cd6c36c8', component.options)
    } else {
      api.reload('cd6c36c8', component.options)
    }
    module.hot.accept("./InvoiceDetailPage.vue?vue&type=template&id=cd6c36c8&", function () {
      api.rerender('cd6c36c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trucking/account-receivable/InvoiceDetailPage.vue"
export default component.exports